import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { unicode, annotation as constants } from './../helpers';
import ConditionalComponent from './ConditionalComponent';

const BuildHealthFeedbackComponent = ({
  isDisabled,
  upVoteCount,
  currentVote,
  downVoteCount,
  onCommentClick,
  onVoteClick
}) => {


  const userNameDependentAction = (newValue) => localStorage.getItem('userName') ?
    onVoteClick(newValue, currentVote) :
    onCommentClick();

  // if we find we need non-binary feedback we can extend this to accept
  // list of options in props and generate from there
  const feedbackItems = (
    <div>
      <Button
        style={{ 'margin': '2px' }}
        id={'up-vote-btn'}
        onClick={() =>
          userNameDependentAction(constants.ALL_ANNOTATIONS_STATUSES.UP_VOTE)}
        active={currentVote.status ===
           constants.ALL_ANNOTATIONS_STATUSES.UP_VOTE}
      >
        {`${unicode.THUMBS_UP} ${upVoteCount}`}
      </Button>
      <Button
        style={{ 'margin': '2px' }}
        id={'down-vote-btn'}
        onClick={() =>
          userNameDependentAction(constants.ALL_ANNOTATIONS_STATUSES.DOWN_VOTE)}
        active={currentVote.status ===
          constants.ALL_ANNOTATIONS_STATUSES.DOWN_VOTE}
      >
        {`${unicode.THUMBS_DOWN} ${downVoteCount}`}
      </Button>
      <Button
        title={'Add Comments'}
        style={{ 'margin': '2px' }}
        id={'write-comment-btn'}
        onClick={() => onCommentClick()}
      >
        {`${unicode.WRITING}`}
      </Button>
    </div>
  );

  return (
    <div>
      <ConditionalComponent
        condition={!isDisabled}
        children={feedbackItems}
      />
    </div>
  );
};

BuildHealthFeedbackComponent.propTypes = {
  isDisabled: PropTypes.bool,
  upVoteCount: PropTypes.number.isRequired,
  downVoteCount: PropTypes.number.isRequired,
  voteTotal: PropTypes.number.isRequired,
  currentVote: PropTypes.shape({
    id: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired
  }).isRequired,
  onCommentClick: PropTypes.func.isRequired,
  onVoteClick: PropTypes.func.isRequired
};

export default BuildHealthFeedbackComponent;


// WEBPACK FOOTER //
// src/Components/BuildHealthFeedbackComponent.jsx